export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13027.ff9f367b.jpg";